const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DeveloperPage/DeveloperPage.tsx';
import * as React from 'react';
import { css, cx } from '@emotion/css';
import { Typography } from '@mui/material';

import { theme } from 'App/utils/clientSetupManager';
import { getPatAppSettings } from 'App/utils/generalUtils';

const spanStyle = css`
    & span {
        margin-right: 5px;
        min-width: 100px;
    }
`;
const flexStyle = css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 98%;
`;

const PageStyle = css`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`;
const frameStyle = css`
    height: 100%;
    margin: 5px;
    display: flex;
    gap: 10px;
`;

const itemStyle = css`
    & > div {
        width: 100%;
        margin: 5px;
        padding: 5px;
        display: flex;
        flex-direction: column;
        word-break: break-all;
    }
`;
const colorPrimary = css`
    background-color: ${theme.palette.primary.main};
`;
const colorSecond = css`
    background-color: ${theme.palette.secondary.main};
`;
const colorError = css`
    background-color: ${theme.palette.error.main};
`;
const colorErrorContrast = css`
    background-color: ${theme.palette.error.contrastText};
`;
const warningLight = css`
    background-color: ${theme.palette.warning.light};
`;
const warningMain = css`
    background-color: ${theme.palette.warning.main};
`;
const warningDark = css`
    background-color: ${theme.palette.warning.dark};
`;

const colorInfo = css`
    background-color: ${theme.palette.info.main};
`;

const colorSuccess = css`
    background-color: ${theme.palette.success.main};
`;

const colorBackgroundPaper = css`
    background-color: ${theme.palette.background.paper};
`;

const colorBackgroundDefault = css`
    background-color: ${theme.palette.background.default};
`;

export const DeveloperPage = () => {
    const settings = getPatAppSettings();

    return (
        <div className={PageStyle}>
            <div className={frameStyle}>
                <div className={cx(flexStyle, itemStyle)}>
                    Typography
                    <div className={cx(flexStyle, itemStyle)}>
                        <Typography variant={'h1'} component="h1">
                            H1
                        </Typography>
                        <Typography variant={'h2'} component="h2">
                            H2
                        </Typography>
                        <Typography variant={'h3'} component="h3">
                            H3 unconfigured
                        </Typography>
                        <Typography variant={'h4'} component="h4">
                            H4 unconfigured
                        </Typography>
                        <Typography variant={'h5'} component="h5">
                            H5
                        </Typography>
                        <Typography variant={'h6'} component="h6">
                            H6
                        </Typography>
                    </div>
                </div>
                <div className={cx(flexStyle, itemStyle)}>
                    Colors
                    <div className={cx(flexStyle, itemStyle, spanStyle)}>
                        <div className={colorPrimary}>
                            <span>primary.main</span> <span>{theme.palette.primary.main}</span>
                        </div>
                        <div className={colorSecond}>
                            <span>second.main</span> <span>{theme.palette.secondary.main}</span>
                        </div>

                        <div className={colorError}>
                            <span>error.main</span> <span>{theme.palette.error.main}</span>
                        </div>
                        <div className={colorErrorContrast}>
                            <span>error.contrastText</span> <span>{theme.palette.error.contrastText}</span>
                        </div>

                        <div className={warningLight}>
                            <span>warning.light</span>
                            <span>-- unused --</span> <span>{theme.palette.warning.light}</span>
                        </div>
                        <div className={warningMain}>
                            <span>warning.main</span> <span>-- unused --</span>
                            <span>{theme.palette.warning.main}</span>
                        </div>
                        <div className={warningDark}>
                            <span>warning.dark</span> <span>-- unused --</span>
                            <span>{theme.palette.warning.dark}</span>
                        </div>

                        <div className={colorInfo}>
                            <span>info.main</span> <span>{theme.palette.info.main}</span>
                        </div>

                        <div className={colorSuccess}>
                            <span>success.main</span>
                            <span>{theme.palette.success.main}</span>
                        </div>

                        <div className={colorBackgroundPaper}>
                            <span>background.paper</span> <span>{theme.palette.background.paper}</span>
                        </div>
                        <div className={colorBackgroundDefault}>
                            <span>background.default</span> <span>{theme.palette.background.default}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cx(flexStyle, itemStyle)}>
                Settings
                <div className={cx(flexStyle, itemStyle, spanStyle)}>{JSON.stringify(settings)}</div>
            </div>
        </div>
    );
};
